export const Marquee = ({ items, accent = false }) => {
  const row = items.join("  ×  ") + "  ×  ";
  return (
    <div
      className={`overflow-hidden border-y py-3 select-none ${
        accent ? "border-[#B7FF2A]/30 bg-[#B7FF2A]/5" : "border-white/10 bg-white/[0.02]"
      }`}
      aria-hidden="true"
    >
      <div className="marquee-track">
        {[0, 1].map((n) => (
          <span
            key={n}
            className={`whitespace-nowrap font-display text-2xl uppercase tracking-[0.18em] ${
              accent ? "text-[#B7FF2A]/80" : "text-white/25"
            }`}
          >
            {row}
          </span>
        ))}
      </div>
    </div>
  );
};
